// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2ETtd","resendInfoText":"OnGoingPaymentBox_resendInfoText__3IZD6"};